import { useTranslation } from "react-i18next";
import { ArrowRight } from "lucide-react";
import { Btn } from "./Btn";
import { Reveal } from "./Reveal";
import { useDemoModal } from "@/components/site/DemoModal";

export const CtaSection = ({ title, sub, product = false }) => {
  const { t } = useTranslation();
  const openDemo = useDemoModal();

  return (
    <section className="px-6 pb-28 pt-4 lg:px-10" data-testid="cta-section">
      <Reveal className="mx-auto max-w-7xl">
        <div className="relative overflow-hidden rounded-3xl bg-ostelo-deep px-8 py-16 sm:px-14 lg:px-20 lg:py-20">
          <div className="pointer-events-none absolute -left-24 -top-24 h-72 w-72 rounded-full border-[26px] border-ostelo-blue/25" />
          <div className="pointer-events-none absolute -bottom-16 left-1/3 h-3 w-3 rounded-full bg-ostelo-orange" />

          <div className={`relative max-w-2xl ${product ? "lg:pr-0" : "lg:pr-52"}`}>
            <h2 className="font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-white sm:text-5xl">
              {title || t("home.final_title")}
            </h2>
            <p className="mt-5 max-w-xl text-base leading-relaxed text-white/65">{sub || t("home.final_sub")}</p>
            <div className="mt-10 flex flex-wrap items-center gap-4">
              <Btn variant="accent" testId="cta-demo-button" onClick={openDemo}>
                {t("common.cta_demo")}
                <ArrowRight size={16} />
              </Btn>
            </div>
          </div>

          {product ? (
            /* Personnage ambassadeur Ostelo — seul élément de la zone droite */
            <>
              <div className="pointer-events-none absolute inset-y-0 right-8 hidden w-[360px] lg:block" data-testid="cta-product">
                <img
                  src="/assets/characters/ambassadeur-400.webp"
                  srcSet="/assets/characters/ambassadeur-400.webp 400w, /assets/characters/ambassadeur-760.webp 760w"
                  sizes="360px"
                  width="760"
                  height="1140"
                  loading="lazy"
                  alt="Ambassadeur Ostelo"
                  className="absolute bottom-0 right-0 h-full w-auto object-contain object-bottom drop-shadow-[0_20px_40px_rgb(0,0,0,0.3)]"
                />
              </div>
            </>
          ) : (
            <div className="pointer-events-none absolute -bottom-2 right-6 hidden w-36 overflow-hidden rounded-t-[4.5rem] shadow-[0_-10px_40px_rgb(0,0,0,0.2)] lg:block" aria-hidden="true">
              <img src="/assets/characters/homme-bras-croises.png" alt="" className="w-full" loading="lazy" />
            </div>
          )}
        </div>
      </Reveal>
    </section>
  );
};
